import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'

export const UserSettingsLink = ({ children }: { children?: JSX.Element }) => (
  <LinkWithoutPrefetch className={'primary-link'} href={`/profile/user-settings`}>
    {children}
  </LinkWithoutPrefetch>
)
